/* eslint-disable no-else-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  TextField,
  Typography,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  Autocomplete,
  DialogContentText,
  Tooltip,
  Box,
  Container
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import numeral from 'numeral';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import AddIcon from '@mui/icons-material/Add';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FlightIcon from '@mui/icons-material/Flight';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ScaleIcon from '@mui/icons-material/Scale';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// For cubic icon (CBM), you can use:
import SquareFootIcon from '@mui/icons-material/SquareFoot'; // or
import AppsIcon from '@mui/icons-material/Apps'; // or use this
import InputIcon from '@mui/icons-material/Input';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import logoImage from '../../media/login/logo.png';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import '../stylemod.css';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

// Country of Origin options
const countryOfOriginOptions = [
  { label: 'United Kingdom (UK)', value: 'UK' },
  { label: 'India (IN)', value: 'IN' },
  { label: 'Sri Lanka (SL)', value: 'SL' },
];

const shipMentTypesforIN = [
  { label: 'Courier', value: 'CO' },
];

const shipMentTypesforUK = [
  { label: 'Courier', value: 'CO' },
  { label: 'Cargo', value: 'CA' },
];

// Add Sri Lanka specific shipment types
const shipMentTypesforSL = [
  { label: 'Courier', value: 'CO' },

];

const DocTypes = [
  { label: 'Document', value: 'Document' },
  { label: 'NonDocument', value: 'NonDocument' },
];

const DimensionType = [
  { label: 'CM', value: 'CM' },
  { label: 'Inch', value: 'Inch' },
];

const BoxType = [
  { label: 'Standard', value: 'Standard' },
  { label: 'Custom', value: 'Custom' },
];

const resetStates = {
  origin: 'UK', // Default to UK if not set
  shipMentType: 'CO',
  docType: 'NonDocument',
  NofoBoxes: 1,
  dimensionType: 'CM',
  senderCountry: '',
  receiverCountry: '',
};

const GetQuotation = () => {

  const navigate = useNavigate();
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [origin, setOrigin] = useState('UK');
  const [initialValue, setInitialValue] = useState(resetStates);
  const [countryList, setCountryList] = useState([]);
  const [boxDetails, setBoxDetails] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [bookingStarted, setBookingStarted] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [uomList, setUOMList] = useState([]);
  const [boxSizeList, setboxSizeList] = useState([]);
  const [shipperPriceData, setShipperPriceData] = useState([]);
  const [cardToggleCourier, setCardToggleCourier] = useState(false);
  const [cardToggleCargo, setCardToggleCargo] = useState(false);
  const [cardHighlight, setCardHighlight] = useState(false);
  const courierRef = useRef(null);
  const cargoRef = useRef(null);
  const [documentType, setDocumentType] = useState('NonDocument');
  const [resetOpenDialog, setResetOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [boxToDelete, setBoxToDelete] = useState(null);
  const [receiverCountryId, setReceiverCountryId] = useState();

   const configuration = {
    headers: {
      Country: origin,
    },
  };
  const GetCountryList = async (db) => {
    try {
      const res = await axios.post('/signup/GetCountryList',{},{
        headers : {
          Country : db
        }
      });
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };


  // Box Size Help
  const GetBoxSizeHelp = async () => {
    try {
      const res = await axios.get('/Quotation/Cargo/GetCargoxBoxSizeHelp');
      setboxSizeList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    GetCountryList(origin);
    GetBoxSizeHelp();
  }, []);

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          origin: Yup.string().required('Country of Origin is required'),
          docType: Yup.string().when('shipMentType', {
            is: (shipMentType) => shipMentType !== 'SCSL',
            then: (schema) => schema.required('Select Type of Document'),
            otherwise: (schema) => schema.notRequired(),
          }),
          NofoBoxes: Yup.number()
            .required('No of boxes is required')
            .min(1, 'Must be at least 1 box')
            .max(10, 'No more than 10 boxes allowed'),
          senderCountry: Yup.string().required('Sender Country is required'),
          receiverCountry: Yup.string().required('Receiver Country is required'),
        })
      ),
    [bookingStarted, origin, initialValue]
  );

  // Function to get shipment types based on origin
  const getShipmentTypesByOrigin = (originValue) => {
    switch (originValue) {
      case 'IN':
        return shipMentTypesforIN;
      case 'SL':
        return shipMentTypesforSL;
      case 'UK':
      default:
        return shipMentTypesforUK;
    }
  };

  const toggleAccordion = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const toggleAccordionTrue = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: true }));
  };

  const handleBoxCountChange = (value, shiptype) => {
    showLoading();
    if (shiptype !== 'SCSL') {
      const boxes = Array.from({ length: value }, (_, index) => ({
        boxNo: index + 1,
        length: '',
        width: '',
        height: '',
        cubicWeight: '',
        grossWeight: '',
        noOfItems: '',
        goods: [],
      }));
      setBoxDetails(boxes);
    } else {
      const boxes = Array.from({ length: value }, (_, index) => ({
        boxNo: index + 1,
        BoxSize: '',
        BoxType: '',
        length: '',
        width: '',
        height: '',
        dimensionType: 'CM',
        cubicWeight: '',
        grossWeight: '',
        noOfItems: '',
        goods: [],
        RatePer: 'CBM',
        Rate: '',
        Duty: '',
        Profit: '',
        ActRate: '',
        actualRate: ''
      }));
      setBoxDetails(boxes);
    }
    hideLoading();
  };

  const handleAddBox = async (setFieldValue, values) => {
    setInitialValue(values);
    if (values.shipMentType !== 'CA') {
      setBoxDetails((prevDetails) => {
        const updatedBoxes = [
          ...prevDetails,
          {
            boxNo: prevDetails.length + 1,
            length: '',
            width: '',
            height: '',
            cubicWeight: '',
            grossWeight: '',
            noOfItems: '',
            goods: [],
          },
        ];
        return updatedBoxes;
      });
    } else {
      setBoxDetails((prevDetails) => {
        const updatedBoxes = [
          ...prevDetails,
          {
            boxNo: prevDetails.length + 1,
            BoxSize: '',
            BoxType: '',
            length: '',
            width: '',
            height: '',
            dimensionType: 'CM',
            cubicWeight: '',
            grossWeight: '',
            noOfItems: '',
            goods: [],
            RatePer: 'CBM',
            Rate: '',
            Duty: '',
            Profit: '',
            ActRate: '',
            actualRate: ''
          },
        ];
        return updatedBoxes;
      });
    }
    setTimeout(async () => {
      await new Promise((resolve) => {
        setFieldValue('NofoBoxes', boxDetails.length + 1, () => resolve());
      });
    }, 1000);
  };

  const handleAddGoods = (boxIndex, newFlag) => {
    showLoading();
    const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0;
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.push({
      goodsName: '',
      uom: '',
      UOM_Id: uom.UOM_Id,
      UOM_Description: uom.UOM_Description,
      quantity: '',
      rate: '',
      value: '',
      newGoods: newFlag,
      image: null,
    });
    setBoxDetails(updatedBoxDetails);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    hideLoading();
  };

  const handleDeleteGoods = (boxIndex, goodsIndex) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.splice(goodsIndex, 1);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    setBoxDetails(updatedBoxDetails);
  };

  const handleGoodsChange = (boxIndex, goodsIndex, field, value) => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];
    if (field === 'goods') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        GoodsName: value.GoodsName,
        GoodsId: value.GoodsId,
      };
    } else if (field === 'uom') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        UOM_Description: value.UOM_Description,
        UOM_Id: value.UOM_Id || 0,
      };
    } else {
      updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    }

    if (field === 'quantity' || field === 'rate') {
      const updatedGoods = updatedBoxDetails[boxIndex].goods[goodsIndex];
      updatedGoods.value = parseFloat((updatedGoods.quantity * updatedGoods.rate).toFixed(2));
    }
    setBoxDetails(updatedBoxDetails);
    hideLoading();
  };

  const getTotalValue = (boxIndex) => {
    const box = boxDetails[boxIndex];
    return parseFloat(
      box.goods.reduce((total, goods) => Number(total) + Number(goods.value), 0).toFixed(2)
    );
  };

  const resetBooking = () => {
    showLoading();
    setInitialValue(resetStates);
    setBoxDetails([]);
    setBookingStarted(false);
    setCardToggleCargo(false);
    setCardToggleCourier(false);
    GetCountryList(origin);
    hideLoading();
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setBoxToDelete(boxIndex);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setBoxToDelete(null);
  };

  const validateBoxDetails = (box, boxIndex, shiptype) => {
    const errors = [];

    if (box.length === '' || Number(box.length) === 0) {
      errors.push(`Row ${boxIndex + 1}: Length is required.`);
    }

    if (box.width === '' || Number(box.width) === 0) {
      errors.push(`Row ${boxIndex + 1}: Width is required.`);
    }

    if (box.height === '' || Number(box.height) === 0) {
      errors.push(`Row ${boxIndex + 1}: Height is required.`);
    }

    if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
      errors.push(`Row ${boxIndex + 1}: Gross Weight is required.`);
    }

    if (shiptype === 'SCSL') {
      if (box.boxType === '' || box.boxType === null) {
        errors.push(`Box ${boxIndex + 1}: Select Box is required.`);
      }

      if (box.boxSize === '' || box.boxSize === null) {
        errors.push(`Box ${boxIndex + 1}: Box Size is required.`);
      }
    }

    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false;
    }

    return true;
  };

  const GetCourierShipperPrice = async (data, receiverCountryids, docType) => {
    const result = data.reduce(
      (acc, item) => {
        const ceilingCubicWeight = Math.ceil(item.cubicWeight || 0);
        const ceilingGrossWeight = Math.ceil(item.grossWeight || 0);
        const higherWeight = Math.max(ceilingCubicWeight, ceilingGrossWeight);
        acc.totalWeight += higherWeight;
        return acc;
      },
      { totalWeight: 0 }
    );
    try {
      const res = await axios.get(
        `/Quotation/Courier/QuotationCourierShipperPrice/${receiverCountryids || receiverCountryId}/${result.totalWeight}/${docType || documentType}`,
        configuration
      );
      if (res.data.length > 0) {
        setShipperPriceData(res.data);
        setCardToggleCourier(true);
      } else {
        setShipperPriceData([]);
        setCardToggleCourier(false);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetCargoNewShipperPrice = async (receiverCountryids, boxCollection) => {
    console.log("boxCollection", boxCollection);
    try {
      const boxData = boxCollection || boxDetails;
         const filteredBoxData = boxData.filter(box => 
      box.cubicWeight && // Check if it exists
      Number(box.cubicWeight) > 0 // Check if it's greater than 0
    );
      const output = filteredBoxData.map(box => ({
        CountryId: receiverCountryids,
        BoxSizeId: parseInt(box.BOXSIZEID, 10) || 0,
        CBM: box.cubicWeight || 0,
        BoxType: box.BoxType
      }));
      const res = await axios.post(`/Quotation/Cargo/GetAllCargoNewShipperPrice`,
        {
          output
        }, configuration);
      if (res.data.output.length > 0) {
        setShipperPriceData(res.data);
        setCardToggleCargo(true);
      } else {
        setShipperPriceData([]);
      }
    } catch (err) {
      console.error("Error updating box prices:", err);
    }
  };

  const startsWithFilter = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.GoodsName || '',
  });

  const handleBoxSizeChange = (index, field, value, values) => {
    showLoading();
    const updatedBoxes = [...boxDetails];
    const rawCubicWeight =
      value.DIMENSION === 'CM'
        ? (Number(value.BOXHEIGHT) / 100) * (Number(value.BOXLENGTH) / 100) * (Number(value.BOXWIDTH) / 100)
        : Number(value.BOXHEIGHT) * 0.0254 * (Number(value.BOXLENGTH) * 0.0254) * (Number(value.BOXWIDTH) * 0.0254);
    if (field === 'BoxSize') {
      updatedBoxes[index] = {
        ...updatedBoxes[index],
        length: value.BOXLENGTH,
        width: value.BOXWIDTH,
        height: value.BOXHEIGHT,
        dimensionType: value.DIMENSION,
        grossWeight: '',
        BOXTYPEID: value.BOXTYPEID,
        BoxSize: value.BOXTYPE,
        BoxNameType: value.BOXSIZE,
        BOXSIZEID: value.BOXSIZEID,
        cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
        BoxType: 'Standard',
      };
    }

    setBoxDetails(updatedBoxes);
    GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
    hideLoading();
  };

  const getCountryName = (countryid) => {
    const countryObj = countryList.find((obj) => obj.CountryId === countryid);
    if (countryObj) {
      return countryObj.CountryName;
    } else {
      return null;
    }
  };

  const handleStartBooking = async (values, validateForm) => {
    // Validate basic form fields
    const formErrors = await validateForm();
    if (Object.keys(formErrors).length > 0) {
      // Show first error
      const firstErrorKey = Object.keys(formErrors)[0];
      openSnackBar(formErrors[firstErrorKey], 'error');
      setTimeout(() => {
        openSnackBar(formErrors[firstErrorKey], 'error');
      }, 100);
      return;
    }

    // Update session storage and state with selected origin
    sessionStorage.setItem('Origin', values.origin);
    setOrigin(values.origin);

    // Start booking
    handleBoxCountChange(values.NofoBoxes, values.shipMentType);
    setBookingStarted(true);
  };

  return (
    <>
    <Container maxWidth={'xl'} sx={{ pt: 2 }}>
  {/* Logo Section */}
 

  <Container  component={Paper} elevation={2} sx={{ p: 3 }}>
 <Box 
  sx={{ 
    display: 'flex', 
    flexDirection: { xs: 'column', sm: 'row' }, // Column on mobile, row on larger screens
    alignItems: 'center',
    justifyContent: { xs: 'center', sm: 'space-between' },
    mb: 2,
    pr: 1,
    gap: 2,
    position: 'relative',
  }}
>
  {/* Logo - Left aligned on desktop, centered on mobile */}
  <Box 
    sx={{ 
      display: 'flex',
      justifyContent: { xs: 'center', sm: 'flex-start' },
      width: { xs: '100%', sm: 'auto' }
    }}
  >
    <img
      src={logoImage}
      alt="Teeparam Logo"
      style={{
        height: '60px',
        width: 'auto',
        objectFit: 'contain',
      }}
    />
  </Box>

  {/* Spacer to push title to the right on larger screens, centered on mobile */}
  <Box sx={{ flex: 1, display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
    <Typography
      variant="h5"
      sx={{
        color: '#11235A',
        textAlign: { xs: 'center', sm: 'right' },
        padding: { xs: '12px 24px', sm: '20px 64px' },
        borderRadius: '16px',
        fontWeight: 700,
        fontSize: { xs: '1.25rem', sm: '1.5rem' },
        textTransform: 'uppercase',
        letterSpacing: { xs: '1px', sm: '2px' },
        overflow: 'hidden',
        position: 'relative',
        width: { xs: '100%', sm: 'auto' },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '4px',
          background: 'linear-gradient(90deg, #000428, #004e92)',
        }
      }}
    >
      Quotation
    </Typography>
  </Box>
</Box>
    {/* Step 1 — Basic Details Header */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        my: 3,
        px: 1,
      }}
    >
      {/* Step badge */}
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #000428 0%, #004e92 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxShadow: '0 4px 14px rgba(0, 78, 146, 0.4)',
        }}
      >
        <AssignmentOutlinedIcon sx={{ color: 'white', fontSize: 22 }} />
      </Box>

      {/* Label */}
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip
            label="STEP 1"
            size="small"
            sx={{
              background: 'linear-gradient(135deg, #000428 0%, #004e92 100%)',
              color: 'white',
              fontWeight: 700,
              fontSize: '0.65rem',
              height: 20,
              letterSpacing: '0.08em',
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: '#11235A', letterSpacing: '0.02em' }}
          >
            Basic Details
          </Typography>
        </Box>
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
          Select origin, shipment type &amp; route
        </Typography>
      </Box>

      {/* Divider line */}
      <Divider sx={{ flex: 1, borderStyle: 'dashed', borderColor: 'rgba(0,78,146,0.25)' }} />
    </Box>
    <Formik
      validationSchema={ValidationSchema}
      initialValues={initialValue}
      onSubmit={(values, { setSubmitting }) => {
        console.log('Form submitted:', values);
        setSubmitting(false);
      }}
    >
      {({
        touched,
        values,
        errors,
        handleChange,
        handleBlur,
        validateForm,
        setFieldValue,
        resetForm,
        setErrors,
        setTouched,
      }) => (
        <Form>
          <Grid container spacing={2} rowSpacing={3}>
            {/* Country of Origin Dropdown */}
            <Grid item md={3} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Country of Origin</InputLabel>
                <Select
                  value={values.origin}
                  name="origin"
                  size="small"
                  label="Country of Origin"
                  onChange={(e) => {
                    handleChange(e);
                  GetCountryList(e.target.value);
                  }}
                  onBlur={handleBlur}
                  error={touched.origin && !!errors.origin}
                  disabled={bookingStarted}
                  required
                >
                  {countryOfOriginOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {touched.origin && errors.origin && (
                  <Typography variant="caption" color="error" className="shake-helper-text" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                    {errors.origin}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item md={3} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Shipment Type</InputLabel>
                <Select
                  value={values.shipMentType}
                  name="shipMentType"
                  size="small"
                  label="Shipment Type"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  error={touched.shipMentType && !!errors.shipMentType}
                  disabled={bookingStarted}
                  required
                >
                  {getShipmentTypesByOrigin(values.origin).map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {touched.shipMentType && errors.shipMentType && (
                  <Typography variant="caption" color="error" className="shake-helper-text" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                    {errors.shipMentType}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            
            <Grid item md={3} xs={12}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                  value={countryList.find((country) => country.CountryId === values.senderCountry) || null}
                  name="senderCountry"
                  onChange={(event, value) => {
                    if (value) {
                      setFieldValue('senderCountry', value.CountryId);
                    } else {
                      setFieldValue('senderCountry', '');
                    }
                  }}
                  onBlur={handleBlur}
                  size="small"
                  required
                  disabled={bookingStarted}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      label="Sender Country"
                      error={Boolean(touched.senderCountry && errors.senderCountry)}
                      helperText={touched.senderCountry && errors.senderCountry ? errors.senderCountry : ''}
                      size="small"
                    />
                  )}
                  noOptionsText="No country available"
                />
              </FormControl>
            </Grid>
            
            <Grid item md={3} xs={12}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                  value={countryList.find((country) => country.CountryId === values.receiverCountry) || null}
                  name="receiverCountry"
                  onChange={(event, value) => {
                    if (value) {
                      setFieldValue('receiverCountry', value.CountryId);
                      setReceiverCountryId(value.CountryId);
                      if (values.shipMentType !== 'CA') {
                        GetCourierShipperPrice(boxDetails, value.CountryId);
                      } else {
                        GetCargoNewShipperPrice(value.CountryId, boxDetails);
                      }
                    } else {
                      setFieldValue('receiverCountry', '');
                    }
                  }}
                  onBlur={handleBlur}
                  size="small"
                  disabled={bookingStarted}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      label="Receiver Country"
                      error={Boolean(touched.receiverCountry && errors.receiverCountry)}
                      helperText={touched.receiverCountry && errors.receiverCountry ? errors.receiverCountry : ''}
                      size="small"
                    />
                  )}
                  noOptionsText="No country available"
                />
              </FormControl>
            </Grid>

            {values.shipMentType !== 'CA' && (
              <>
                <Grid item md={2} xs={12}>
                  <FormControl fullWidth size="small" required>
                    <InputLabel>Document Type</InputLabel>
                    <Select
                      value={values.docType || ''}
                      name="docType"
                      size="small"
                      label="Document Type"
                      onChange={async (event) => {
                        handleChange(event);
                        const data = event.target.value;
                        setDocumentType(data);
                        setInitialValue(() => ({ ...values, docType: data }));
                        GetCourierShipperPrice(boxDetails, values.receiverCountry, data);
                      }}
                      onBlur={handleBlur}
                      error={touched.docType && !!errors.docType}
                      required
                      disabled={bookingStarted}
                    >
                      {DocTypes.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.docType && errors.docType && (
                      <Typography variant="caption" color="error" className="shake-helper-text" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                        {errors.docType}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item md={!bookingStarted ? 2 : values.shipMentType !== 'CA' ? 1 : 3} xs={12}>
                  <FormControl fullWidth size="small" required>
                    <InputLabel>Dimension</InputLabel>
                    <Select
                      value={values.dimensionType || ''}
                      name="dimensionType"
                      size="small"
                      label="Dimension Type"
                      onChange={async (event) => {
                        handleChange(event);
                        const data = event.target.value;
                        setInitialValue(() => ({ ...values, dimensionType: data }));

                        if (boxDetails.length > 0) {
                          const updatedBoxes = boxDetails.map((box) => {
                            const rawCubicWeight =
                              data === 'CM'
                                ? (box.height * box.width * box.length) / 5000
                                : (box.height * box.width * box.length) / 1925;
                            return {
                              ...box,
                              cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
                            };
                          });
                          setBoxDetails(updatedBoxes);
                          GetCourierShipperPrice(updatedBoxes);
                        }
                      }}
                      onBlur={handleBlur}
                      error={touched.dimensionType && !!errors.dimensionType}
                      required
                      disabled={bookingStarted}
                    >
                      {DimensionType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.dimensionType && errors.dimensionType && (
                      <Typography variant="caption" color="error" className="shake-helper-text" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                        {errors.dimensionType}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </>
            )}
            
            <Grid item md={values.shipMentType !== 'CA' ? 2 : 3} xs={12}>
              <TextField
                fullWidth
                size="small"
                label="No of Boxes"
                type="number"
                name="NofoBoxes"
                // disabled={bookingStarted}
                disabled
                onBlur={handleBlur}
                error={touched.NofoBoxes && errors.NofoBoxes}
                helperText={touched.NofoBoxes && errors.NofoBoxes ? errors.NofoBoxes : ''}
                value={values.NofoBoxes}
                required
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </Grid>

            {/* Buttons Section */}
            <Grid item md={1} xs={12}>
              <Stack direction="row" spacing={2}>
                {bookingStarted && (
                  <Button
                    variant="outlined"
                    color="error"
                    size="medium"
                    sx={{
                      flex: 1,
                      fontWeight: 600,
                      borderRadius: '8px',
                      borderWidth: 2,
                      '&:hover': {
                        borderWidth: 2,
                        backgroundColor: 'rgba(211,47,47,0.06)',
                      },
                    }}
                    type="button"
                    onClick={() => {
                      setResetOpenDialog(true);
                    }}
                  >
                    Reset
                  </Button>
                )}

                {!bookingStarted && (
                  <Button
                    variant="contained"
                    size="medium"
                    type="button"
                    onClick={async () => {
                      await handleStartBooking(values, validateForm);
                    }}
                    sx={{
                      flex: 1,
                      background: 'linear-gradient(135deg, #000428 0%, #004e92 100%)',
                      color: 'white',
                      fontWeight: 700,
                      borderRadius: '8px',
                      letterSpacing: '0.04em',
                      boxShadow: '0 4px 14px rgba(0, 78, 146, 0.4)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #004e92 0%, #000428 100%)',
                        boxShadow: '0 6px 18px rgba(0, 78, 146, 0.55)',
                        transform: 'translateY(-1px)',
                      },
                      transition: 'all 0.25s ease',
                    }}
                  >
                    Next
                    <NavigateNextIcon sx={{ ml: 0.5, fontSize: 20 }} />
                  </Button>
                )}
              </Stack>
            </Grid>
          </Grid>

          {/* Box Details Section */}
          {bookingStarted && (
            <Box mt={4}>

              {/* Step 2 — Package Details Header */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mb: 3,
                  px: 1,
                }}
              >
                {/* Step badge */}
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    boxShadow: '0 4px 14px rgba(17, 153, 142, 0.4)',
                  }}
                >
                  <Inventory2OutlinedIcon sx={{ color: 'white', fontSize: 22 }} />
                </Box>

                {/* Label */}
                <Box sx={{ minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                      label="STEP 2"
                      size="small"
                      sx={{
                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                        color: 'white',
                        fontWeight: 700,
                        fontSize: '0.65rem',
                        height: 20,
                        letterSpacing: '0.08em',
                      }}
                    />
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: '#11235A', letterSpacing: '0.02em' }}
                    >
                      Package Details
                    </Typography>
                  </Box>
                  <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
                    Enter dimensions &amp; weight for each package
                  </Typography>
                </Box>

                {/* Divider line */}
                <Divider sx={{ flex: 1, borderStyle: 'dashed', borderColor: 'rgba(17,153,142,0.3)' }} />
              </Box>

              {boxDetails.length > 0 && boxDetails.map((box, index) => (
                <Paper
                  key={index}
                  sx={{
                    backgroundColor: 'inherit',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    borderRadius: 2,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                    overflow: 'hidden',
                    mt: 2,
                    mb: 2,
                  }}
                  elevation={0}
                >
                  {/* Box card accent header */}
                  <Box
                    sx={{
                      background: 'linear-gradient(90deg, #000428 0%, #004e92 70%, #0072c6 100%)',
                      px: 2.5,
                      py: 1.25,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: '50%',
                          backgroundColor: 'rgba(255,255,255,0.18)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography variant="caption" sx={{ color: 'white', fontWeight: 700, lineHeight: 1 }}>
                          {box.boxNo}
                        </Typography>
                      </Box>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: 'white', fontWeight: 700, letterSpacing: '0.04em' }}
                      >
                        Box {box.boxNo}
                      </Typography>
                      <Chip
                        label="Dimensions & Weights"
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(255,255,255,0.15)',
                          color: 'rgba(255,255,255,0.9)',
                          fontWeight: 500,
                          fontSize: '0.65rem',
                          height: 20,
                          border: '1px solid rgba(255,255,255,0.25)',
                        }}
                      />
                    </Stack>
                    {boxDetails.length > 1 && (
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleOpenConfirmDialog(index)}
                        size="small"
                        sx={{
                          color: 'rgba(255,255,255,0.8)',
                          '&:hover': {
                            backgroundColor: 'rgba(211,47,47,0.3)',
                            color: 'white',
                          },
                        }}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>

                  {/* Box card body */}
                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      {values.shipMentType !== 'CA' ? (
                        /* Courier Box Fields */
                        <>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              size="small"
                              fullWidth
                              label="Length"
                              type="number"
                              value={box.length}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newLength = parseFloat(e.target.value) || '';
                                if (newLength > 0 || newLength === '') {
                                  updatedBoxes[index].length = newLength;
                                  const rawCubicWeight =
                                    values.dimensionType === 'CM'
                                      ? (box.height * box.width * newLength) / 5000
                                      : (box.height * box.width * newLength) / 1925;
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCourierShipperPrice(updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].length`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].length`] &&
                                touched[`boxDetails[${index}].length`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].length`] &&
                                errors[`boxDetails[${index}].length`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Width"
                              type="number"
                              value={box.width}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newWidth = parseFloat(e.target.value) || '';
                                if (newWidth > 0 || newWidth === '') {
                                  updatedBoxes[index].width = newWidth;
                                  const rawCubicWeight =
                                    values.dimensionType === 'CM'
                                      ? (box.height * box.length * newWidth) / 5000
                                      : (box.height * box.length * newWidth) / 1925;
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCourierShipperPrice(updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].width`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].width`] &&
                                touched[`boxDetails[${index}].width`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].width`] &&
                                errors[`boxDetails[${index}].width`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Height"
                              type="number"
                              value={box.height}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newHeight = parseFloat(e.target.value) || '';
                                if (newHeight > 0 || newHeight === '') {
                                  updatedBoxes[index].height = newHeight;
                                  const rawCubicWeight =
                                    values.dimensionType === 'CM'
                                      ? (newHeight * box.length * box.width) / 5000
                                      : (newHeight * box.length * box.width) / 1925;
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCourierShipperPrice(updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].height`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].height`] &&
                                touched[`boxDetails[${index}].height`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].height`] &&
                                errors[`boxDetails[${index}].height`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Cubic Weight"
                              type="number"
                              value={box.cubicWeight}
                              disabled
                              name={`boxDetails[${index}].cubicWeight`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].cubicWeight`] &&
                                touched[`boxDetails[${index}].cubicWeight`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].cubicWeight`] &&
                                errors[`boxDetails[${index}].cubicWeight`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Gross Weight"
                              type="number"
                              value={box.grossWeight}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newGrossWeight = parseFloat(e.target.value) || '';
                                if (newGrossWeight > 0 || newGrossWeight === '') {
                                  updatedBoxes[index].grossWeight = newGrossWeight;
                                  setBoxDetails(updatedBoxes);
                                  GetCourierShipperPrice(updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].grossWeight`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].grossWeight`] &&
                                touched[`boxDetails[${index}].grossWeight`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].grossWeight`] &&
                                errors[`boxDetails[${index}].grossWeight`]
                              }
                            />
                          </Grid>
                           <Grid item md={2} xs={12}>
                         
              <AddCircleOutlineIcon
                      onClick={() => {
                        handleAddBox(setFieldValue, values);
                      }}
                      sx={{
                        cursor: 'pointer',
                        color: 'info.main', // Or any color you want
                        fontSize: '2.3rem', // Adjust size
                        boxShadow: 1,
                        borderRadius: '50%', // Optional: make it circular
                        padding: '4px', // Optional: add some padding
                        '&:hover': {
                          color: 'info.dark',
                          transform: 'scale(1.1)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    />
              
              </Grid>
                        </>
                      ) : (
                        /* Cargo Box Fields */
                        <>
                          <Grid item md={3} xs={12}>
                            <Autocomplete
                              fullWidth
                              size="small"
                              options={BoxType}
                              getOptionLabel={(option) => option.label || ''}
                              renderOption={(props, option) => (
                                <li {...props} key={option.value}>
                                  {option.label}
                                </li>
                              )}
                              value={BoxType.find((item) => item.value === box.BoxType) || null}
                              onChange={(event, value) => {
                                const updatedBoxes = [...boxDetails];
                                updatedBoxes[index] = {
                                  ...updatedBoxes[index],
                                  BoxType: value ? value.value : null,
                                  length: '',
                                  width: '',
                                  height: '',
                                  dimensionType: 'CM',
                                  BOXTYPEID: null,
                                  BoxSize: '',
                                  grossWeight: '',
                                  cubicWeight: '',
                                };
                                setBoxDetails(updatedBoxes);
                                setInitialValue(values);
                              }}
                              isOptionEqualToValue={(option, value) => option.value === value?.value}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  label="Select Box"
                                  name={`boxDetails[${index}].BoxType`}
                                  onBlur={handleBlur}
                                  error={Boolean(
                                    errors[`boxDetails[${index}].BoxType`] &&
                                    touched[`boxDetails[${index}].BoxType`]
                                  )}
                                  helperText={
                                    touched[`boxDetails[${index}].BoxType`] &&
                                    errors[`boxDetails[${index}].BoxType`]
                                  }
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            {box.BoxType === 'Custom' ? (
                              <TextField
                                required
                                fullWidth
                                size="small"
                                label="Box Type"
                                type="text"
                                value={box.BoxSize}
                                onChange={(e) => {
                                  const updatedBoxes = [...boxDetails];
                                  updatedBoxes[index].BoxSize = e.target.value;
                                  setBoxDetails(updatedBoxes);
                                }}
                                name={`boxDetails[${index}].BoxSize`}
                                onBlur={handleBlur}
                                error={Boolean(
                                  errors[`boxDetails[${index}].BoxSize`] &&
                                  touched[`boxDetails[${index}].BoxSize`]
                                )}
                                helperText={
                                  touched[`boxDetails[${index}].BoxSize`] &&
                                  errors[`boxDetails[${index}].BoxSize`]
                                }
                              />
                              
                            ) : (
                              <Autocomplete
                                fullWidth
                                size="small"
                                options={boxSizeList}
                                getOptionLabel={(option) => `${option.BOXTYPE} (${option.BOXSIZE})` || ''}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.BOXTYPEID}>
                                    {`${option.BOXTYPE} (${option.BOXSIZE})`}
                                  </li>
                                )}
                                value={boxSizeList.find((item) => item.BOXTYPEID === box.BOXTYPEID) || null}
                                onChange={(event, value) => {
                                  handleBoxSizeChange(index, 'BoxSize', value || {}, values);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option.BOXTYPEID === value?.BOXTYPEID
                                }
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    label="Box Type"
                                    name={`boxDetails[${index}].BoxSize`}
                                    error={Boolean(
                                      errors[`boxDetails[${index}].BoxSize`] &&
                                      touched[`boxDetails[${index}].BoxSize`]
                                    )}
                                    helperText={
                                      touched[`boxDetails[${index}].BoxSize`] &&
                                      errors[`boxDetails[${index}].BoxSize`]
                                    }
                                    onBlur={handleBlur}
                                  />
                                )}
                              />
                            )}
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              size="small"
                              fullWidth
                              label="Length"
                              type="number"
                              disabled={box.BoxType !== 'Custom'}
                              value={box.length}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newLength = parseFloat(e.target.value) || '';
                                if (newLength > 0 || newLength === '') {
                                  updatedBoxes[index].length = newLength;
                                  const rawCubicWeight =
                                    box.dimensionType === 'CM'
                                      ? (Number(box.height) / 100) *
                                        (Number(newLength) / 100) *
                                        (Number(box.width) / 100)
                                      : Number(box.height) *
                                        0.0254 *
                                        (Number(newLength) * 0.0254) *
                                        (Number(box.width) * 0.0254);
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].length`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].length`] &&
                                touched[`boxDetails[${index}].length`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].length`] &&
                                errors[`boxDetails[${index}].length`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Width"
                              type="number"
                              disabled={box.BoxType !== 'Custom'}
                              value={box.width}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newWidth = parseFloat(e.target.value) || '';
                                if (newWidth > 0 || newWidth === '') {
                                  updatedBoxes[index].width = newWidth;
                                  const rawCubicWeight =
                                    box.dimensionType === 'CM'
                                      ? (Number(box.height) / 100) *
                                        (Number(box.length) / 100) *
                                        (Number(newWidth) / 100)
                                      : Number(box.height) *
                                        0.0254 *
                                        (Number(box.length) * 0.0254) *
                                        (Number(newWidth) * 0.0254);
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].width`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].width`] &&
                                touched[`boxDetails[${index}].width`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].width`] &&
                                errors[`boxDetails[${index}].width`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Height"
                              type="number"
                              disabled={box.BoxType !== 'Custom'}
                              value={box.height}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newHeight = parseFloat(e.target.value) || '';
                                if (newHeight > 0 || newHeight === '') {
                                  updatedBoxes[index].height = newHeight;
                                  const rawCubicWeight =
                                    box.dimensionType === 'CM'
                                      ? (Number(newHeight) / 100) *
                                        (Number(box.length) / 100) *
                                        (Number(box.width) / 100)
                                      : Number(newHeight) *
                                        0.0254 *
                                        (Number(box.length) * 0.0254) *
                                        (Number(box.width) * 0.0254);
                                  updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                  setBoxDetails(updatedBoxes);
                                  GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].height`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].height`] &&
                                touched[`boxDetails[${index}].height`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].height`] &&
                                errors[`boxDetails[${index}].height`]
                              }
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <Autocomplete
                              fullWidth
                              size="small"
                              clearIcon={false}
                              options={DimensionType}
                              getOptionLabel={(option) => option.label || ''}
                              renderOption={(props, option) => (
                                <li {...props} key={option.value}>
                                  {option.label}
                                </li>
                              )}
                              value={DimensionType.find((item) => item.value === box.dimensionType) || null}
                              disabled={box.BoxType !== 'Custom'}
                              onChange={(event, value) => {
                                const updatedBoxes = [...boxDetails];
                                updatedBoxes[index] = {
                                  ...updatedBoxes[index],
                                  dimensionType: value ? value.value : null,
                                };
                                const rawCubicWeight =
                                  value.value === 'CM'
                                    ? (Number(box.height) / 100) *
                                      (Number(box.length) / 100) *
                                      (Number(box.width) / 100)
                                    : Number(box.height) *
                                      0.0254 *
                                      (Number(box.length) * 0.0254) *
                                      (Number(box.width) * 0.0254);
                                updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                setBoxDetails(updatedBoxes);
                                GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                              }}
                              isOptionEqualToValue={(option, value) => option.value === value?.value}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  label="Dimension"
                                  name={`boxDetails[${index}].dimensionType`}
                                  onBlur={handleBlur}
                                  error={Boolean(
                                    errors[`boxDetails[${index}].dimensionType`] &&
                                    touched[`boxDetails[${index}].dimensionType`]
                                  )}
                                  helperText={
                                    touched[`boxDetails[${index}].dimensionType`] &&
                                    errors[`boxDetails[${index}].dimensionType`]
                                  }
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="CBM"
                              type="number"
                              value={box.cubicWeight}
                              disabled
                              name={`boxDetails[${index}].cubicWeight`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].cubicWeight`] &&
                                touched[`boxDetails[${index}].cubicWeight`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].cubicWeight`] &&
                                errors[`boxDetails[${index}].cubicWeight`]
                              }
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="Gross Weight"
                              type="number"
                              value={box.grossWeight}
                              onChange={(e) => {
                                const updatedBoxes = [...boxDetails];
                                const newGrossWeight = parseFloat(e.target.value) || '';
                                if (newGrossWeight > 0 || newGrossWeight === '') {
                                  updatedBoxes[index].grossWeight = newGrossWeight;
                                  setBoxDetails(updatedBoxes);
                                }
                              }}
                              name={`boxDetails[${index}].grossWeight`}
                              onBlur={handleBlur}
                              error={Boolean(
                                errors[`boxDetails[${index}].grossWeight`] &&
                                touched[`boxDetails[${index}].grossWeight`]
                              )}
                              helperText={
                                touched[`boxDetails[${index}].grossWeight`] &&
                                errors[`boxDetails[${index}].grossWeight`]
                              }
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                          <AddCircleOutlineIcon
                      onClick={() => {
                        handleAddBox(setFieldValue, values);
                      }}
                      sx={{
                        cursor: 'pointer',
                        color: 'info.main', // Or any color you want
                        fontSize: '2.3rem', // Adjust size
                        boxShadow: 1,
                        borderRadius: '50%', // Optional: make it circular
                        padding: '4px', // Optional: add some padding
                        '&:hover': {
                          color: 'info.dark',
                          transform: 'scale(1.1)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    />
              </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>
                </Paper>
              ))}
              
              {/* Show Quote Button */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  variant="contained"
                  size="large"
                  disabled={!(cardToggleCourier || cardToggleCargo)}
                  onClick={async () => {
                    showLoading();
                    try {
                      if (values.shipMentType !== 'CA') {
                        await GetCourierShipperPrice(boxDetails, values.receiverCountry, values.docType || documentType);
                        setCardToggleCourier(true);
                        setCardHighlight(true);
                        courierRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        setTimeout(() => setCardHighlight(false), 1800);
                      } else {
                        await GetCargoNewShipperPrice(values.receiverCountry, boxDetails);
                        setCardToggleCargo(true);
                        setCardHighlight(true);
                        cargoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        setTimeout(() => setCardHighlight(false), 1800);
                      }
                    } catch (err) {
                      console.error(err);
                    }
                    hideLoading();
                  }}
                  sx={{
                    background: (cardToggleCourier || cardToggleCargo)
                      ? 'linear-gradient(135deg, #000428 0%, #004e92 100%)'
                      : undefined,
                    color: 'white',
                    fontWeight: 500,
                    borderRadius: '10px',
                    px: 2,
                    py: 1,
                    fontSize: '0.95rem',
                    letterSpacing: '0.04em',
                    boxShadow: (cardToggleCourier || cardToggleCargo)
                      ? '0 6px 20px rgba(0,78,146,0.35)'
                      : 'none',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #004e92 0%, #000428 100%)',
                      boxShadow: '0 10px 28px rgba(0,78,146,0.5)',
                      transform: 'translateY(-2px)',
                    },
                    transition: 'all 0.25s ease',
                  }}
                >
                  Show Quote
                </Button>
              </Box>
            </Box>
          )}

          {/* Confirmation Dialog for Deletion */}
          <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <Typography>Are you sure you want to delete this box?</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmDialog} color="primary">
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  showLoading();
                  setInitialValue(values);
                  const updatedBoxDetails = [...boxDetails];
                  updatedBoxDetails.splice(boxToDelete, 1);
                  const reIndexedBoxDetails = updatedBoxDetails.map((box, index) => ({
                    ...box,
                    boxNo: index + 1,
                  }));

                  setBoxDetails(reIndexedBoxDetails);
                  if (values.shipMentType !== 'CA') {
                    GetCourierShipperPrice(reIndexedBoxDetails);
                  } else {
                    GetCargoNewShipperPrice(values.receiverCountry, reIndexedBoxDetails);
                  }
                  setTimeout(async () => {
                    await new Promise((resolve) => {
                      setFieldValue('NofoBoxes', reIndexedBoxDetails.length, () => resolve());
                    });
                  }, 1000);
                  hideLoading();
                  handleCloseConfirmDialog();
                }}
                color="error"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>

          {/* Confirmation Reset Dialog */}
          <Dialog
            open={resetOpenDialog}
            onClose={() => setResetOpenDialog(false)}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
          >
            <DialogTitle id="confirm-dialog-title">Confirm Reset</DialogTitle>
            <DialogContent>
              <DialogContentText id="confirm-dialog-description">
                Are you sure you want to reset the form? This action cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setResetOpenDialog(false)} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  resetForm();
                  resetBooking();
                  setErrors({});
                  setTouched({});
                  setResetOpenDialog(false);
                }}
                color="error"
                autoFocus
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          
          
          {/* Price Cards - Keep your existing price card components */}
        {/* Courier Price Section */}
{cardToggleCourier && shipperPriceData.length > 0 && shipperPriceData[0].weight > 0 && (
  <Box
    ref={courierRef}
    sx={{
      mt: 4,
      mb: 3,
      borderRadius: '20px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '24px',
      boxShadow: cardHighlight
        ? '0 0 0 10px rgba(0,212,255,0.10), 0 32px 60px rgba(0,150,255,0.18)'
        : '0 20px 40px rgba(102, 126, 234, 0.3)',
      transform: cardHighlight ? 'translateY(-5px)' : 'none',
      transition: 'box-shadow 0.4s ease, transform 0.4s ease',
      animation: cardHighlight ? 'cardPop 1.8s ease-out' : 'none',
      '@keyframes cardPop': {
        '0%': { boxShadow: '0 0 0 0 rgba(0,212,255,0.15)' },
        '40%': { boxShadow: '0 0 0 14px rgba(0,212,255,0.06)' },
        '100%': { boxShadow: '0 20px 40px rgba(102,126,234,0.3)' },
      },
      border: '1px solid rgba(255, 255, 255, 0.2)',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #00d4ff, #0099ff, #00d4ff)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2s infinite linear',
        '@keyframes shimmer': {
          '0%': { backgroundPosition: '-200% 0' },
          '100%': { backgroundPosition: '200% 0' },
        },
      },
    }}
  >
    {/* Close button */}
    <IconButton
      onClick={() => setCardToggleCourier(false)}
      sx={{
        position: 'absolute',
        top: 12,
        right: 12,
        color: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          transform: 'rotate(90deg)',
        },
        transition: 'all 0.3s ease',
      }}
      size="small"
    >
      <CloseIcon />
    </IconButton>

    {/* Header */}
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
      <FlightIcon sx={{ color: 'white', fontSize: 28 }} />
      <Typography
        variant="h5"
        sx={{
          color: 'white',
          fontWeight: 'bold',
          textShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}
      >
        Courier shipping Rate
      </Typography>
    </Stack>

    {/* Route Info */}
    <Box
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        borderRadius: '12px',
        padding: '16px',
        mb: 3,
        backdropFilter: 'blur(10px)',
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={8}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 0.5 }}>
            Shipping Route
          </Typography>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
            {`${getCountryName(values.senderCountry)} → ${getCountryName(values.receiverCountry)}`}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              padding: '8px 16px',
              borderRadius: '20px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <ScaleIcon sx={{ fontSize: 18, color: 'white' }} />
            <Typography variant="body1" sx={{ color: 'white', fontWeight: 'bold' }}>
              {shipperPriceData[0].weight} kg
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>

    {/* Rates Grid */}
    <Grid container spacing={2}>
      {shipperPriceData.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Paper
            elevation={0}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '16px',
              padding: '16px',
              height: '100%',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
              },
            }}
          >
            <Stack spacing={1}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <FiberManualRecordIcon sx={{ fontSize: 8, color: '#00d4ff' }} />
                {item.ShipperLinerName || 'Carrier'}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                }}
              >
                {item.symbol}{numeral(item.Price).format('0,0.00')}
              </Typography>
               <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                <strong>Note:</strong>  The price shown is an estimate and may change after the parcel’s weight and dimensions are verified
              </Typography> 
               <Button
                variant="contained"
                onClick={() => {
                  const basename = `/${process.env.PUBLIC_URL.split('/').pop()}`;
                  window.open(`${basename}/login`, '_blank')
                                }}

                sx={{
                  background: 'linear-gradient(135deg, #00d4ff 0%, #0099ff 100%)',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '10px',
                  mt: 1,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0099ff 0%, #00d4ff 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 12px rgba(0, 148, 255, 0.3)',
                  },
                  transition: 'all 0.3s ease',
                }}
                fullWidth
              >
                <LocalShippingIcon sx={{ mr: 1, fontSize: 18 }} />
                Book Now
              </Button>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
)}

{/* Cargo Price Section */}
{cardToggleCargo && shipperPriceData?.output?.length > 0 && (
  <Box
    ref={cargoRef}
      sx={{
      mt: 4,
      mb: 3,
      borderRadius: '20px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '24px',
      boxShadow: cardHighlight
        ? '0 0 0 10px rgba(0,212,255,0.10), 0 32px 60px rgba(0,150,255,0.18)'
        : '0 20px 40px rgba(102, 126, 234, 0.3)',
      transform: cardHighlight ? 'translateY(-5px)' : 'none',
      transition: 'box-shadow 0.4s ease, transform 0.4s ease',
      animation: cardHighlight ? 'cardPop 1.8s ease-out' : 'none',
      '@keyframes cardPop': {
        '0%': { boxShadow: '0 0 0 0 rgba(0,212,255,0.15)' },
        '40%': { boxShadow: '0 0 0 14px rgba(0,212,255,0.06)' },
        '100%': { boxShadow: '0 20px 40px rgba(102,126,234,0.3)' },
      },
      border: '1px solid rgba(255, 255, 255, 0.2)',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #00d4ff, #0099ff, #00d4ff)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2s infinite linear',
        '@keyframes shimmer': {
          '0%': { backgroundPosition: '-200% 0' },
          '100%': { backgroundPosition: '200% 0' },
        },
      },
    }}
  >
    <IconButton
      onClick={() => setCardToggleCargo(false)}
      sx={{
        position: 'absolute',
        top: 12,
        right: 12,
        color: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          transform: 'rotate(90deg)',
        },
        transition: 'all 0.3s ease',
      }}
      size="small"
    >
      <CloseIcon />
    </IconButton>

    {/* Header */}
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
      <DirectionsBoatIcon sx={{ color: 'white', fontSize: 28 }} />
      <Typography
        variant="h5"
        sx={{
          color: 'white',
          fontWeight: 'bold',
          textShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}
      >
        Cargo Shipping Rate
      </Typography>
    </Stack>

    {/* Route & CBM Info */}
    <Box
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        borderRadius: '12px',
        padding: '16px',
        mb: 3,
        backdropFilter: 'blur(10px)',
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 0.5 }}>
            Shipping Route
          </Typography>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
            {`${getCountryName(values.senderCountry)} → ${getCountryName(values.receiverCountry)}`}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 0.5 }}>
            Volume
          </Typography>
          <Box
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              padding: '8px 16px',
              borderRadius: '20px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <SquareFootIcon sx={{ fontSize: 18, color: 'white' }} />
            <Typography variant="body1" sx={{ color: 'white', fontWeight: 'bold' }}>
              {shipperPriceData.totalCBM || 0} CBM
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>

    {/* Rates Grid */}
    <Grid container spacing={2}>
      {shipperPriceData?.output.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Paper
            elevation={0}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '16px',
              padding: '16px',
              height: '100%',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
              },
            }}
          >
            <Stack spacing={1}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <FiberManualRecordIcon sx={{ fontSize: 8, color: '#4facfe' }} />
                {item.ShipperLinerName || 'Carrier'}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                }}
              >
                {item.Symbol}{numeral(item.totalNetRate).format('0,0.00')}
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                <strong>Note:</strong>  The price shown is an estimate and may change after the parcel’s weight and dimensions are verified
              </Typography>
              <Button
                variant="contained"
                onClick={() => {
                  const basename = `/${process.env.PUBLIC_URL.split('/').pop()}`;
                  window.open(`${basename}/login`, '_blank')
                                }}
                sx={{
                  background: 'linear-gradient(135deg, #00d4ff 0%, #0099ff 100%)',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '10px',
                  mt: 1,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0099ff 0%, #00d4ff 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 12px rgba(0, 148, 255, 0.3)',
                  },
                  transition: 'all 0.3s ease',
                }}
                fullWidth
              >
                <LocalShippingIcon sx={{ mr: 1, fontSize: 18 }} />
                Book Now
              </Button>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
)}
        </Form>
      )}
    </Formik>
  </Container>
</Container>
    </>
  );
};

export default GetQuotation;